import _ from "lodash";
import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import ReportSummary from "./reports/summary";
import apontamentoReport from "./reports/index";

export default class ADC extends Indicador {
    static get fullName() {
        return "Aferição de Dosagem de Composto";
    }

    static get abbrev() {
        return "ADC";
    }

    static get field() {
        return "adc";
    }

    static get multTipo() {
        return true
    }

    static get legacyApontamentoMap() {
        return {
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",
            turno: "turno",


            insumo: "insumo",
            dosagemRecomendada: "dosagemRecomendada",


            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    pesagem: "pesagem",
                    observacaoColeta: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",
            afericao: "afericao",
            mediaColetas: "media",
            dosePorMetro: "doseMetro",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            intervaloAderenciaMinimoManual: "manual.intervaloMin",
            intervaloAderenciaMaximoManual: "manual.intervaloMax",
            metrosLinearesAmostraManual: "manual.metrosLinearesAmostra",
            metrosLinearesHectareManual: "manual.metrosLinearesHectare",
            metaADCManual: "manual.meta",

            intervaloAderenciaMinimoMecanizado: "mecanizado.intervaloMin",
            intervaloAderenciaMaximoMecanizado: "mecanizado.intervaloMax",
            metrosLinearesAmostraMecanizado: "mecanizado.metrosLinearesAmostra",
            metrosLinearesHectareMecanizado: "mecanizado.metrosLinearesHectare",
            metaADCMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumPesagem = 0;

        for (const coleta of apontamento.coletas) {
            if (coleta.pesagem) {
                sumPesagem += f(coleta.pesagem);
            }
        }

        apontamento.media = sumPesagem / total;
        apontamento.media = apontamento.media.toFixed(4);

        // Dose por metro linear média das coletas.
        apontamento.doseMetro = apontamento.media / f(params.metrosLinearesAmostra);
        apontamento.doseMetro = apontamento.doseMetro.toFixed(4);

        apontamento.afericao = apontamento.doseMetro * f(params.metrosLinearesHectare);
        apontamento.afericao = apontamento.afericao.toFixed(4);

        const dosagemRecomendada = f(apontamento.dosagemRecomendada);

        if (!_.isNaN(dosagemRecomendada)) {
            const rawConformidade = (apontamento.afericao / f(apontamento.dosagemRecomendada)) * 100;
            apontamento.acima = rawConformidade > f(params.intervaloMax) ? 1 : 0;
            apontamento.abaixo = rawConformidade < f(params.intervaloMin) ? 1 : 0;
            let conformidade = rawConformidade > 100 ? rawConformidade - 200 : rawConformidade;

            return Math.abs(conformidade).toFixed(2);
        } else {
            apontamento.acima = 0;
            apontamento.abaixo = 0;
            return 0;
        }
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 94.73, 100, 103.15);
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },
            { title: "Insumo", field: "insumo.nomeInsumo", width: 'auto' },

            { title: "Dosagem Recomendada", field: "dosagemRecomendada", width: 'auto' },
            { title: "Média", width: 'auto', getValue: (a) => parseFloat(a.media).toFixed(2) },
            { title: "Aferição", width: 'auto', getValue: (a) => parseFloat(a.afericao).toFixed(2) },
            { title: "Dose/Metro", width: 'auto', getValue: (a) => parseFloat(a.doseMetro).toFixed(2) },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        return "Dosagem Recomendada: " + apontamento.dosagemRecomendada +
            ", Média: " + parseFloat(apontamento.media).toFixed(2) +
            ", Aferição: " + parseFloat(apontamento.afericao).toFixed(2) +
            " e Dose/Metro: " + parseFloat(apontamento.doseMetro).toFixed(2)
    }
}
